import axios from "axios"
import { APIURL } from "src/config/helpers/base"


export const setDataHomes = (rows = 10, pageNum = 1, sort = 1, search = '', tag = '') => {
    return (dispatch) => {
        dispatch({ type: 'DATA_HOMES', payload: false })
        axios.get(`${APIURL}/one/Dataset/GetDatasetHome`).then(res => {
            var data = res.data;
            dispatch({ type: 'DATA_HOMES', payload: data })
        })
    }
}
export const setDataNews = () => {
    return (dispatch) => {
        dispatch({ type: 'DATA_NEWS', payload: false })
        axios.get(`${APIURL}/one/Webs/GetAppNews`).then(res => {
            var data = res.data;
            dispatch({ type: 'DATA_NEWS', payload: data })
        })
    }
}